import { ANALYTICS_API_NAME, BEACON_EXECUTE_TIME } from "../spnAnalytics/analyticsEnum";

class QueueManager {
  /**
   * The constructor function is a function that is called when a new object is created
   * @param obj @type {Object} - This is the object that is passed to the constructor.
   */
  constructor(obj) {
    this.queue = obj;
    this.platform = this.queue.platformType;
    this.dataStoreObj = obj.dataStoreObj;
    this.networkManager = obj.networkManagerObj;
    this.godavariStatus = obj.analyticsConfig.GODAVARI_ENABLED;
    this.allSessionVideoErrorKey = obj.godavariStateAllSessionErrorKey;
    this.allSessionVideoEndKey = obj.godavariStateAllSessionVideoEndKey;
    window.addEventListener('online', this.checkNetworkOnline);
    window.addEventListener('offline', this.checkNetworkOffline);
  }

  updateAnalyticsConfig(params) {
    this.godavariStatus = params.GODAVARI_ENABLED;
  }

  updatePlatformType(platform = "WEB") {
    this.platform = platform;
  }

  /**
   * This function will check local storage is set or not.
   * then return data from local storage
   * @param key @type {string} - Pass key to get data
   */
  checkStorageData(key) {
    try {
      if (
        this.dataStoreObj.getData(key) == null ||
        this.dataStoreObj.getData(key) == ""
      ) {
        var storage_key = [];
        this.dataStoreObj.setData(key, storage_key);
        return this.dataStoreObj.getData(key);
      } else {
        return this.dataStoreObj.getData(key);
      }
    } catch (exception) {
      return false;
    }
  }

  /**
   * This function will store update data in local storage.
   * @param key @type {string} - Key name.
   * @param val @type {json} -  Data.
   */
  manageStorageData(key, val) {
    try {
      this.dataStoreObj.storeUpdateData(key, val);
    } catch {
      // if (e.name === 'QuotaExceededError') {
      this.updateStorageGetError(key, val);
      //}
    }
  }

  updateStorageGetError = (key, val) => {
    try {
      this.removeGodavariDataFromStorage();
      let godavariMainKey = [];
      let session_id =
        "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
      godavariMainKey.push(session_id);
      localStorage.setItem(
        "ANALYTICS_KEY_LISTS",
        JSON.stringify(godavariMainKey)
      );
      this.dataStoreObj.storeUpdateData(key, val);
    } catch {
      // error
    }
  };

  removeGodavariDataFromStorage = () => {
    try {
      let analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
      if (analyticsKeyList) {
        var analyticsKeyListArr = JSON.parse(analyticsKeyList);
        if (analyticsKeyListArr != null && analyticsKeyListArr.length > 0) {
          for (var i = 0; i < analyticsKeyListArr.length; i++) {
            localStorage.removeItem(analyticsKeyListArr[i]);
          }
        }
      }
      localStorage.removeItem("ANALYTICS_KEY_LISTS");
      localStorage.removeItem("ANALYTICS_ALL_ERROR_DATA");
      localStorage.removeItem("ANALYTICS_ALL_END_DATA");
    } catch {
      // get error
    }
  };

  /**
   * This function will manage local storage data.
   * @param apiName @type {string} - which class to pass data.
   * @param eventName @type {string} -  event name.
   * @param payLoadBody @type {json} -  Json Data.
   */
  nextStoragePostData(apiName, eventName, payLoadBody) {
    if (this.godavariStatus) {
      this.checkStorageData("spnWebSdkAnalytics");
      let session_id =
        "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
      var localStorageData = JSON.parse(
        this.dataStoreObj.getStorageData(session_id)
      );

      var data = {
        apiname: apiName,
        eventname: eventName,
        payloadbody: payLoadBody,
      };
      localStorageData.push(data);
      this.manageStorageData(session_id, localStorageData);
      if (eventName == "AppSessionEnd") {
        return;
      }
      if (window.checkBeaconNetworkStatus && window.networkOnProcess) {
        window.networkOnProcess = false;
        this.processQueue();
      }
    }
  }

  /**
   * If the queue is not active, then activate it and execute the local storage.
   */
  processQueue() {
    if (window.checkBeaconNetworkStatus && window.networkOnProcess == false) {
      this.executeLocalStorage();
    }
  }

  /**
   * This function will process the data in the local storage and send it to the server.
   * It will also remove the data from the local storage.
   * this Will be called from Network Response.
   * this will be called from the constructor.
   * this will be called from the nextStoragePostData.
   * on current page load
   */
  executeLocalStorage() {
    try {

      if (!window.checkBeaconNetworkStatus) {
        return;
      }
      if (window.networkOnProcess) {
        return;
      }

      this.checkStorageData("spnWebSdkAnalytics");
      let session_id =
        "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;

      let localStorageData = [];
      try {
        localStorageData = JSON.parse(
          this.dataStoreObj.getStorageData(session_id)
        );
      } catch (error) {
        console.log(error);
      }

      if (localStorageData.length == 0) {
        window.networkOnProcess = true;
        return;
      }

      var networkPromise = this.networkManager.networkProcessApi(localStorageData[0]);

      networkPromise.then((apiResponse) => {
        this.cleanCurrentSessionBeacons(apiResponse, session_id);
        this.handleCurrentSessionNextBeaconExecute(apiResponse, session_id);
      });

      networkPromise.catch((err) => {
        if (window.checkBeaconNetworkStatus || window?.navigator?.onLine) {
          let apiResponse = 0;
          this.cleanCurrentSessionBeacons(apiResponse, session_id);
          this.handleCurrentSessionNextBeaconExecute(apiResponse, session_id);
          window.networkOnProcess = true;
        }
      });
    } catch (e) {
      window.networkOnProcess = true;
    }
  }

  cleanCurrentSessionBeacons = (apiResponse, session_id) => {
    if (apiResponse == 200 || apiResponse == 0) {
      let localStorageData = [];
      try {
        localStorageData = JSON.parse(
          this.dataStoreObj.getStorageData(session_id)
        );
      } catch (error) {
        console.log(error);
      }
      if (typeof localStorageData === "object" && localStorageData !== null) {
        localStorageData.shift();
        this.dataStoreObj.storeUpdateData(session_id, localStorageData);
      }
    }
  }

  handleCurrentSessionNextBeaconExecute = (apiResponse, session_id) => {
    if (apiResponse == 200 || apiResponse == 0) {
      // when beacons pass
      var localStorageData = JSON.parse(
        this.dataStoreObj.getStorageData(session_id)
      );
      if (localStorageData != null &&
        localStorageData.length > 0 &&
        window.networkOnProcess == false
      ) {
        setTimeout(() => {
          this.executeLocalStorage();
        }, 500);
      } else {
        window.networkOnProcess = true;
      }
    }
  }

  /**
   * I'm trying to get the last stored data from the local storage and send it to the server.
   *
   * I'm using the following code to get the last stored data:
   * when user come with new page load
   */
  handleLastSessionData = () => {
    let session_id =
      "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
    let analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
    let allLastSessionKey = [];
    if (analyticsKeyList) {
      var analyticsKeyListArr = JSON.parse(analyticsKeyList);
      if (analyticsKeyListArr != null && analyticsKeyListArr.length > 0) {
        for (var i = 0; i < analyticsKeyListArr.length; i++) {
          if (session_id != analyticsKeyListArr[i] && this.checkIsEligible(analyticsKeyListArr[i])) {
            allLastSessionKey.push(analyticsKeyListArr[i]);
          }
        }
      }
    }
    this.handleEachLastSessionData(allLastSessionKey);
  }

  handlePreviousSessionOfflineExecute = () => {
    let session_id =
      "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
    let analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
    let allLastSessionKey = [];
    if (analyticsKeyList) {
      let analyticsKeyListArr = [];
      try {
        analyticsKeyListArr = JSON.parse(analyticsKeyList);
      } catch (error) {
        console.log(error);
      }
      if (analyticsKeyListArr != null && analyticsKeyListArr.length > 0) {
        for (var i = 0; i < analyticsKeyListArr.length; i++) {
          if (session_id != analyticsKeyListArr[i] && this.checkIsEligible(analyticsKeyListArr[i])) {
            allLastSessionKey.push(analyticsKeyListArr[i]);
          }
        }
      }
    }
    this.handleEachLastSessionData(allLastSessionKey);
  }

  /**
   * It takes an array of keys, and for each key, it takes the data from local storage, sends it to
   * the server, and then removes the key from local storage.
   * the server. It is sending only the first key's data to the server.
   * @param allLastSessionKey - ["session_key_1", "session_key_2", "session_key_3"]
   */
  handleEachLastSessionData(allLastSessionKey) {
    try {
      if (!window.checkBeaconNetworkStatus) {
        return;
      }
      if (!allLastSessionKey || allLastSessionKey.length == 0) {
        return;
      }

      let eachLastSessionKey = allLastSessionKey[0];
      let eachLastSessionDataStr = localStorage.getItem(eachLastSessionKey);
      if (!eachLastSessionDataStr) {
        this.removeSessionKey(eachLastSessionKey, allLastSessionKey);
        return;
      }
      let eachLastSessionDataArr = [];
      try {
        eachLastSessionDataArr = JSON.parse(eachLastSessionDataStr);
      } catch (error) {
        console.log(error);
      }
      if (eachLastSessionDataArr.length == 0) {
        this.removeSessionKey(eachLastSessionKey, allLastSessionKey);
        return;
      }

      var networkPromise = this.networkManager.networkProcessApi(eachLastSessionDataArr[0]);

      networkPromise.then((apiResponse) => {
        this.cleanEachBeacons(apiResponse, eachLastSessionKey);
        this.handleNextBeaconExecute(apiResponse, eachLastSessionKey, allLastSessionKey);
      });

      networkPromise.catch((err) => {
        if (window.checkBeaconNetworkStatus || window?.navigator?.onLine) {
          let apiResponse = 0;
          this.cleanEachBeacons(apiResponse, eachLastSessionKey);
          this.handleNextBeaconExecute(apiResponse, eachLastSessionKey, allLastSessionKey);
        }
      });

    } catch (e) {
      SPN_Console.error("Storage error");
    }
  }

  cleanEachBeacons = (apiResponse, eachLastSessionKey) => {
    if (apiResponse == 200 || apiResponse == 0) {
      let eachLastSessionKeyData = [];
      try {
        eachLastSessionKeyData = JSON.parse(
          localStorage.getItem(eachLastSessionKey)
        );
      } catch (error) {
        console.log(error);
      }
      if (typeof eachLastSessionKeyData === "object" && eachLastSessionKeyData !== null) {
        eachLastSessionKeyData.shift();
        this.dataStoreObj.storeUpdateData(
          eachLastSessionKey,
          eachLastSessionKeyData
        );
      }
    }
  }

  handleNextBeaconExecute = (apiResponse, eachLastSessionKey, allLastSessionKey) => {
    if (apiResponse == 200 || apiResponse == 0) {
      // when beacons pass or fail
      var localStorageData = JSON.parse(
        this.dataStoreObj.getStorageData(eachLastSessionKey)
      );
      if (typeof localStorageData === "object" && localStorageData !== null && localStorageData.length > 0) {
        setTimeout(() => {
          this.handleEachLastSessionData(allLastSessionKey)
        }, 500);
      } else {
        this.removeSessionKey(eachLastSessionKey, allLastSessionKey);
      }
    } else {
      this.removeSessionKey(eachLastSessionKey, allLastSessionKey);
    }
  }

  removeSessionKey = (eachLastSessionKey, allLastSessionKey) => {
    if (localStorage.getItem(eachLastSessionKey)) {
      localStorage.removeItem(eachLastSessionKey);
    }
    this.removeThisKeyFromList(eachLastSessionKey);
    allLastSessionKey.shift();
    this.handleEachLastSessionData(allLastSessionKey);
  };

  /**
   * It removes a key from a list of keys stored in localStorage.
   * @param eachLastSessionKey - This is the key that you want to remove from the list.
   * @returns A boolean value.
   */
  removeThisKeyFromList = (eachLastSessionKey) => {
    try {
      let analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
      analyticsKeyList = JSON.parse(analyticsKeyList);
      const keyPosition = analyticsKeyList.indexOf(eachLastSessionKey);
      if (keyPosition > -1) {
        analyticsKeyList.splice(keyPosition, 1);
        localStorage.setItem(
          "ANALYTICS_KEY_LISTS",
          JSON.stringify(analyticsKeyList)
        );
      }
    } catch (e) {
      SPN_Console.error("Storage error");
    }
    return true;
  }

  checkNetworkOnline = () => {
    if (window.checkBeaconNetworkStatus == false) {
      window.checkBeaconNetworkStatus = true;
      window.networkOnProcess = false;
      this.executeLocalStorage();
      this.handlePreviousSessionOfflineExecute();
    }
  }

  checkNetworkOffline = () => {
    if (window.checkBeaconNetworkStatus) {
      window.checkBeaconNetworkStatus = false;
      window.networkOnProcess = true;
    }
  }

  checkIsEligible = (sessionKey) => {
    let OneDay = new Date().getTime() + (24 * 60 * 60 * 1000);
    let localStorageData = [];
    try {
      localStorageData = JSON.parse(
        this.dataStoreObj.getStorageData(sessionKey)
      );
      if (typeof localStorageData === "object" && localStorageData != null && localStorageData.length > 0) {
        let lastIndex = localStorageData.slice(-1);
        let sessionTime = lastIndex?.[0]?.payloadbody?.event?.wc ? lastIndex[0].payloadbody.event.wc : 0;
        if (parseInt(sessionTime) >= parseInt(OneDay)) {
          this.discardSession(sessionKey);
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
      return true;
    }

  }

  discardSession = (sessionKey) => {
    try {
      let analyticsKeyList = [];
      analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
      analyticsKeyList = JSON.parse(analyticsKeyList);
      const keyPosition = analyticsKeyList.indexOf(sessionKey);
      if (keyPosition > -1) {
        localStorage.removeItem(sessionKey);
        analyticsKeyList.splice(keyPosition, 1);
        localStorage.setItem(
          "ANALYTICS_KEY_LISTS",
          JSON.stringify(analyticsKeyList)
        );
      }
    } catch (e) {
      SPN_Console.error("Storage error");
    }
  }

  // check length of analytics session list
  checkAnalyticsPreviousSessionLength = () => {
    var analyticsKeyList = []
    var arrayList = [];
    try {
      let session_id =
        "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
      analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
      analyticsKeyList = JSON.parse(analyticsKeyList);
      if (analyticsKeyList != null && analyticsKeyList.length > 50) {
        for (var i = 0; i < analyticsKeyList.length; i++) {
          if (session_id != analyticsKeyList[i]) {
            if (localStorage.getItem(analyticsKeyList[i])) {
              localStorage.removeItem(analyticsKeyList[i]);
            }
            arrayList.push(i);
          }
        }
        if (arrayList != null && arrayList.length > 0) {
          analyticsKeyList = analyticsKeyList.filter((value, index) => !arrayList.includes(index));
        }
        localStorage.setItem(
          "ANALYTICS_KEY_LISTS",
          JSON.stringify(analyticsKeyList)
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  //================== godavari Modified Player State ===================

  //Mock error
  handleAllErrorSessionId() {
    let localStorageData = {};
    let finalSessionList = [];
    try {
      localStorageData = JSON.parse(
        this.dataStoreObj.getStorageData(this.allSessionVideoErrorKey)
      );
      if (Object.keys(localStorageData).length > 0) {
        let sessionList = Object.keys(localStorageData);
        // 30 min
        let timeDuration = (this.platform == "WEB" || this.platform == "MWEB") ? BEACON_EXECUTE_TIME.AllError : 0;
        if (localStorage.getItem("ALL_ERROR_TIME")) {
          timeDuration = localStorage.getItem("ALL_ERROR_TIME");
          timeDuration = parseInt(timeDuration);
        }
        for (let i = 0; i < sessionList.length; i++) {
          if (localStorageData.hasOwnProperty(sessionList[i])) {
            let sessionTime = localStorageData[sessionList[i]].time;
            sessionTime = parseInt(sessionTime);
            let fallbackTime = new Date(sessionTime);
            let currentTime = new Date();
            let calculateTimeDiff = this.timeDiffMinutes(fallbackTime, currentTime);
            if (parseInt(calculateTimeDiff) >= parseInt(timeDuration)) {
              finalSessionList.push(sessionList[i]);
            }
          }
        }
        if (finalSessionList.length > 0) {
          this.executeAllErrorLocalStorage(finalSessionList);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  //Mock error
  executeAllErrorLocalStorage(sessionIdList) {
    try {
      if (!window.checkBeaconNetworkStatus) {
        return;
      }
      let localStorageData = {};
      try {
        localStorageData = JSON.parse(
          this.dataStoreObj.getStorageData(this.allSessionVideoErrorKey)
        );
      } catch (error) {
        console.log(error);
      }
      if (Object.keys(localStorageData).length == 0) {
        return;
      }
      let sessiondata = localStorageData[sessionIdList[0]];
      var networkPromise = this.networkManager.networkProcessApi(sessiondata);
      networkPromise.then((apiResponse) => {
        this.cleanAllError(apiResponse, sessionIdList);
      });
      networkPromise.catch((err) => {
        let apiResponse = 0;
        this.cleanAllError(apiResponse, sessionIdList);
      });
    } catch (e) {
    }
  }
  //Mock error
  cleanAllError(apiResponse, sessionIdList) {
    if (apiResponse == 200 || apiResponse == 0) {
      let localStorageData = {};
      try {
        localStorageData = JSON.parse(
          this.dataStoreObj.getStorageData(this.allSessionVideoErrorKey)
        );
      } catch (error) {
        console.log(error);
      }
      if (Object.keys(localStorageData).length > 0) {
        if (localStorageData.hasOwnProperty(sessionIdList[0])) {
          delete localStorageData[sessionIdList[0]];
          this.manageStorageData(this.allSessionVideoErrorKey, localStorageData);
        }
        sessionIdList.shift();
        if (sessionIdList.length > 0) {
          setTimeout(() => {
            this.executeAllErrorLocalStorage(sessionIdList);
          }, 100);
        }
      }

    }
  }

  //Mock video end
  handleAllVideoEndSessionId() {
    let localStorageData = {};
    let finalSessionList = [];
    try {
      localStorageData = JSON.parse(
        this.dataStoreObj.getStorageData(this.allSessionVideoEndKey)
      );
      if (Object.keys(localStorageData).length > 0) {
        let sessionList = Object.keys(localStorageData);
        // 30 min
        let timeDuration = (this.platform == "WEB" || this.platform == "MWEB") ? BEACON_EXECUTE_TIME.AllVideoEnd : 0;
        if (localStorage.getItem("ALL_VIDEO_END_TIME")) {
          timeDuration = localStorage.getItem("ALL_VIDEO_END_TIME");
          timeDuration = parseInt(timeDuration);
        }

        for (let i = 0; i < sessionList.length; i++) {
          if (localStorageData.hasOwnProperty(sessionList[i])) {
            let sessionTime = localStorageData[sessionList[i]].time;
            sessionTime = parseInt(sessionTime);
            let fallbackTime = new Date(sessionTime);
            let currentTime = new Date();
            let calculateTimeDiff = this.timeDiffMinutes(fallbackTime, currentTime);
            if (parseInt(calculateTimeDiff) >= parseInt(timeDuration)) {
              finalSessionList.push(sessionList[i]);
            }
          }
        }
        if (finalSessionList.length > 0) {
          this.executeAllVideoEndLocalStorage(finalSessionList);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  //Mock video end
  executeAllVideoEndLocalStorage(sessionIdList) {
    try {
      if (!window.checkBeaconNetworkStatus) {
        return;
      }
      let localStorageData = {};
      try {
        localStorageData = JSON.parse(
          this.dataStoreObj.getStorageData(this.allSessionVideoEndKey)
        );
      } catch (error) {
        console.log(error);
      }
      if (Object.keys(localStorageData).length == 0) {
        return;
      }
      let sessiondata = localStorageData[sessionIdList[0]];
      var networkPromise = this.networkManager.networkProcessApi(sessiondata);
      networkPromise.then((apiResponse) => {
        this.cleanAllVideoEnd(apiResponse, sessionIdList);
      });
      networkPromise.catch((err) => {
        let apiResponse = 0;
        this.cleanAllVideoEnd(apiResponse, sessionIdList);
      });
    } catch (e) {
    }
  }
  //Mock video end
  cleanAllVideoEnd(apiResponse, sessionIdList) {
    if (apiResponse == 200 || apiResponse == 0) {
      let localStorageData = {};
      try {
        localStorageData = JSON.parse(
          this.dataStoreObj.getStorageData(this.allSessionVideoEndKey)
        );
      } catch (error) {
        console.log(error);
      }
      if (Object.keys(localStorageData).length > 0) {
        if (localStorageData.hasOwnProperty(sessionIdList[0])) {
          delete localStorageData[sessionIdList[0]];
          this.manageStorageData(this.allSessionVideoEndKey, localStorageData);
        }
        sessionIdList.shift();
        if (sessionIdList.length > 0) {
          setTimeout(() => {
            this.executeAllVideoEndLocalStorage(sessionIdList);
          }, 100);
        }
      }
    }
  }

  timeDiffMinutes(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  }

  removeUnusedGodavariKeyFromStorage() {
    try {
      var analyticsKeyList = []
      let session_id =
        "ANALYTICS_" + window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
      analyticsKeyList = localStorage.getItem("ANALYTICS_KEY_LISTS");
      var analyticsKeyListArr = JSON.parse(analyticsKeyList);

      for (var index = 0; index < localStorage.length; index++) {
        let analyticsKeyName = localStorage?.key(index);
        if (analyticsKeyName?.substring(0, 10) == "ANALYTICS_" && session_id != analyticsKeyName) {
          let analyticsKey = analyticsKeyName?.split("_");
          let keyName = parseInt(analyticsKey[1]);
          if (Number.isInteger(keyName)) {
            if (!analyticsKeyListArr?.includes(analyticsKeyName)) {
              localStorage.removeItem(analyticsKeyName);
            }
          }
        }
      }

    } catch (error) {
      console.error(error);
    }
  }

}

export default QueueManager;
